import { render, staticRenderFns } from "./RiskScore.vue?vue&type=template&id=147a0a64&scoped=true"
import script from "./RiskScore.vue?vue&type=script&lang=ts"
export * from "./RiskScore.vue?vue&type=script&lang=ts"
import style0 from "./RiskScore.vue?vue&type=style&index=0&id=147a0a64&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "147a0a64",
  null
  
)

export default component.exports